export const seqPostfix = {
  1: { ko: "첫", en: "first" },
  2: { ko: "두", en: "second" },
  3: { ko: "세", en: "third" },
  4: { ko: "네", en: "fourth" },
  5: { ko: "다섯", en: "fifth" },
  6: { ko: "여섯", en: "sixth" },
  7: { ko: "일곱", en: "seventh" },
  8: { ko: "여덟", en: "Eighth" },
  9: { ko: "아홉", en: "Ninth" },
  10: { ko: "열", en: "first" },
  11: { ko: "열한", en: "first" },
  12: { ko: "열두", en: "second" },
  13: { ko: "열세", en: "third" },
  14: { ko: "열네", en: "fourth" },
  15: { ko: "열다섯", en: "fifth" },
  16: { ko: "열여섯", en: "sixth" },
  17: { ko: "열일곱", en: "seventh" },
  18: { ko: "열여덟", en: "Eighth" },
  19: { ko: "열아홉", en: "" },
  20: { ko: "스무", en: "" },
  21: { ko: "스물한", en: "" },
  22: { ko: "스물두", en: "" },
  23: { ko: "스물세", en: "" },
  24: { ko: "스물네", en: "" },
  25: { ko: "스물다섯", en: "" },
  26: { ko: "스물여섯", en: "" },
  27: { ko: "스물일곱", en: "" },
  28: { ko: "스물여덟", en: "" },
  29: { ko: "스물아홉", en: "" },
  30: { ko: "서른", en: "" },
  31: { ko: "서른한", en: "" },
  32: { ko: "서른두", en: "" },
  33: { ko: "서른세", en: "" },
  34: { ko: "서른네", en: "" },
  35: { ko: "서른다섯", en: "" },
  36: { ko: "서른여섯", en: "" },
  37: { ko: "서른일곱", en: "" },
  38: { ko: "서른여덟", en: "" },
  39: { ko: "서른아홉", en: "" },
  40: { ko: "마흔", en: "" },
  41: { ko: "마흔한", en: "" },
  42: { ko: "마흔두", en: "" },
  43: { ko: "마흔세", en: "" },
  44: { ko: "마흔네", en: "" },
  45: { ko: "마흔다섯", en: "" },
  46: { ko: "마흔여섯", en: "" },
  47: { ko: "마흔일곱", en: "" },
  48: { ko: "마흔여덟", en: "" },
  49: { ko: "마흔아홉", en: "" },
  50: { ko: "쉰", en: "" },
  51: { ko: "쉰한", en: "" },
  52: { ko: "쉰두", en: "" },
  53: { ko: "쉰세", en: "" },
  54: { ko: "쉰네", en: "" },
  55: { ko: "쉰다섯", en: "" },
  56: { ko: "쉰여섯", en: "" },
  57: { ko: "쉰일곱", en: "" },
  58: { ko: "쉰여덟", en: "" },
  59: { ko: "쉰아홉", en: "" },
  60: { ko: "예순", en: "" },
  61: { ko: "예순한", en: "" },
  62: { ko: "예순두", en: "" },
  63: { ko: "예순세", en: "" },
  64: { ko: "예순네", en: "" },
  65: { ko: "예순다섯", en: "" },
  66: { ko: "예순여섯", en: "" },
  67: { ko: "예순일곱", en: "" },
  68: { ko: "예순여덟", en: "" },
  69: { ko: "예순아홉", en: "" },
  70: { ko: "일흔", en: "" },
  71: { ko: "일흔한", en: "" },
  72: { ko: "일흔두", en: "" },
  73: { ko: "일흔세", en: "" },
  74: { ko: "일흔네", en: "" },
  75: { ko: "일흔다섯", en: "" },
  76: { ko: "일흔여섯", en: "" },
  77: { ko: "일흔일곱", en: "" },
  78: { ko: "일흔여덟", en: "" },
  79: { ko: "일흔아홉", en: "" },
  80: { ko: "여든", en: "" },
  81: { ko: "여든한", en: "" },
  82: { ko: "여든두", en: "" },
  83: { ko: "여든세", en: "" },
  84: { ko: "여든네", en: "" },
  85: { ko: "여든다섯", en: "" },
  86: { ko: "여든여섯", en: "" },
  87: { ko: "여든일곱", en: "" },
  88: { ko: "여든여덟", en: "" },
  89: { ko: "여든아홉", en: "" },
  90: { ko: "아흔", en: "" },
  91: { ko: "아흔한", en: "" },
  92: { ko: "아흔두", en: "" },
  93: { ko: "아흔세", en: "" },
  94: { ko: "아흔네", en: "" },
  95: { ko: "아흔다섯", en: "" },
  96: { ko: "아흔여섯", en: "" },
  97: { ko: "아흔일곱", en: "" },
  98: { ko: "아흔여덟", en: "" },
  99: { ko: "아흔아홉", en: "" },
  100: { ko: "백", en: "" },
};

export const seqPostfix_ko = {
  1: "첫",
  2: "두",
  3: "세",
  4: "네",
  5: "다섯",
  6: "여섯",
  7: "일곱",
  8: "여덟",
  9: "아홉",
  10: "열",
  11: "열한",
  12: "열두",
  13: "열세",
  14: "열네",
  15: "열다섯",
  16: "열여섯",
  17: "열일곱",
  18: "열여덟",
  19: "열아홉",
  20: "스무",
  21: "스물한",
  22: "스물두",
  23: "스물세",
  24: "스물네",
  25: "스물다섯",
  26: "스물여섯",
  27: "스물일곱",
  28: "스물여덟",
  29: "스물아홉",
  30: "서른",
  31: "서른한",
  32: "서른두",
  33: "서른세",
  34: "서른네",
  35: "서른다섯",
  36: "서른여섯",
  37: "서른일곱",
  38: "서른여덟",
  39: "서른아홉",
  40: "마흔",
  41: "마흔한",
  42: "마흔두",
  43: "마흔세",
  44: "마흔네",
  45: "마흔다섯",
  46: "마흔여섯",
  47: "마흔일곱",
  48: "마흔여덟",
  49: "마흔아홉",
  50: "쉰",
  51: "쉰한",
  52: "쉰두",
  53: "쉰세",
  54: "쉰네",
  55: "쉰다섯",
  56: "쉰여섯",
  57: "쉰일곱",
  58: "쉰여덟",
  59: "쉰아홉",
  60: "예순",
  61: "예순한",
  62: "예순두",
  63: "예순세",
  64: "예순네",
  65: "예순다섯",
  66: "예순여섯",
  67: "예순일곱",
  68: "예순여덟",
  69: "예순아홉",
  70: "일흔",
  71: "일흔한",
  72: "일흔두",
  73: "일흔세",
  74: "일흔네",
  75: "일흔다섯",
  76: "일흔여섯",
  77: "일흔일곱",
  78: "일흔여덟",
  79: "일흔아홉",
  80: "여든",
  81: "여든한",
  82: "여든두",
  83: "여든세",
  84: "여든네",
  85: "여든다섯",
  86: "여든여섯",
  87: "여든일곱",
  88: "여든여덟",
  89: "여든아홉",
  90: "아흔",
  91: "아흔한",
  92: "아흔두",
  93: "아흔세",
  94: "아흔네",
  95: "아흔다섯",
  96: "아흔여섯",
  97: "아흔일곱",
  98: "아흔여덟",
  99: "아흔아홉",
  100: "백",
};
